export default {
  "content": "<path d=\"M23.207 17.793a1 1 0 01.068 1.338l-.068.076-4.5 4.5-1.414-1.414 2.793-2.793H10v-2h10.086l-2.793-2.793 1.414-1.414 4.5 4.5z\" fill=\"#7B61FF\"/><path d=\"M10 3.5a1 1 0 01.781.375L12.481 6H21a1 1 0 011 1v5h-2V8h-8a1 1 0 01-.781-.375L9.519 5.5H4v12h4v2H3a1 1 0 01-1-1v-14a1 1 0 011-1h7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};